import { render } from "./pring-gaji-query-terpisah-per-tabel.vue?vue&type=template&id=f8e70da8&scoped=true"
import script from "./pring-gaji-query-terpisah-per-tabel.vue?vue&type=script&lang=js"
export * from "./pring-gaji-query-terpisah-per-tabel.vue?vue&type=script&lang=js"

import "./pring-gaji-query-terpisah-per-tabel.vue?vue&type=style&index=0&id=f8e70da8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e70da8"]])

export default __exports__